import { render, staticRenderFns } from "./header.vue?vue&type=template&id=debfc12e&scoped=true"
var script = {}
import style0 from "./header.vue?vue&type=style&index=0&id=debfc12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debfc12e",
  null
  
)

export default component.exports